import { connect } from "react-redux";
import { Link, useLocation, Navigate, Route, Routes } from "react-router-dom";

import { ClipboardIcon } from "@/icons/outline";

import AdvisorGeneralSettings from "./AdvisorGeneralSettings";
import AdvisorPayroll from "./AdvisorPayroll";

const tabs = [
	{
		link: "/advisor/settings/general",
		name: "General",
	},
	{
		link: "/advisor/settings/payroll",
		name: "Payroll",
	},
];

const AdvisorBillingNavigation = ({ isAdmin, advisor }) => {
	const location = useLocation();
	const currentTab = location.pathname;
	return (
		<>
			<div className="content bg-gray-lighter">
				<div className="row">
					<div className="col-sm-12">
						<div className="pull-left">
							<h1 className="page-heading">Settings</h1>
						</div>
						{isAdmin && (
							<div
								className="btn btn-default pull-right"
								onClick={() => navigator.clipboard.writeText(advisor)}
								style={{ marginRight: 10 }}
							>
								<ClipboardIcon style={{ height: "1.5em", float: "left" }} />
								<div style={{ float: "left" }}>Copy ID</div>
							</div>
						)}
					</div>
				</div>
			</div>
			<div className="content bg-white">
				<ul className="nav nav-tabs nav-tabs-alt nav-justified">
					{tabs.map((tab) => {
						return (
							<li className={currentTab === tab.link ? "active" : ""}>
								<Link to={tab.link}>{tab.name}</Link>
							</li>
						);
					})}
				</ul>

				<Routes>
					<Route
						path="/general"
						element={<AdvisorGeneralSettings />}
					/>
					<Route
						path="/payroll"
						element={<AdvisorPayroll />}
					/>
					<Route
						path="*"
						element={
							<Navigate
								to="/advisor/settings/general"
								replace
							/>
						}
					/>
				</Routes>
			</div>
		</>
	);
};

const mapStateToProps = (state) => {
	return {
		isAdmin: state.my.profile.isAdmin,
		advisor: state.advisors?.settings?.id,
	};
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(AdvisorBillingNavigation);
